<template>
  <svg class="svg-icon" aria-hidden="true" :width="size + 'px'" :height="size + 'px'">
    <use :xlink:href="iconClass"></use>
  </svg>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "SvgIcon",
  isGlobal: true,
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 20,
    },
  },
  setup(props) {
    const iconClass = computed(() => {
      return `#icon-${props.iconClass}`;
    });

    return {
      iconClass,
    };
  },
});
</script>
